import React from 'react';
import Menu from "../components/navbar.js";
export const ErrorPage = () => {
    return (
        <div>
             <Menu/> 
            <h1>Error 404!</h1>
            <h1>The page you are looking for could not be found.</h1>
        </div>
    );
};
